// extracted by mini-css-extract-plugin
export default {"serverNameInput":"Server_serverNameInput__erNJy"};